
import React, { useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { BarChart3Icon, UsersIcon, BookOpenIcon, AwardIcon, HomeIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbSeparator } from "@/components/ui/breadcrumb";

// We'll create these components next
import CourseFeedbackAnalytics from "@/components/feedback-analytics/CourseFeedbackAnalytics";
import TrainerFeedbackAnalytics from "@/components/feedback-analytics/TrainerFeedbackAnalytics";
import DemographicFeedbackAnalytics from "@/components/feedback-analytics/DemographicFeedbackAnalytics";
import RequirementsFeedbackAnalytics from "@/components/feedback-analytics/RequirementsFeedbackAnalytics";

const FeedbackAnalytics = () => {
  const navigate = useNavigate();
  const [activeView, setActiveView] = useState("courses");

  return (
    <div className="container mx-auto p-6 space-y-6">
      <div className="flex flex-col gap-2">
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Button 
                  variant="link" 
                  className="p-0 font-subtitle"
                  onClick={() => navigate("/admin/feedback")}
                >
                  <HomeIcon className="h-4 w-4 mr-2" />
                  Feedback Reports
                </Button>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbLink className="font-subtitle">
                Advanced Analytics
              </BreadcrumbLink>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>

        <h1 className="text-3xl font-bold tracking-tight font-title text-primary">Advanced Feedback Analytics</h1>
        <p className="text-muted-foreground font-subtitle">
          Analyze feedback data across multiple dimensions
        </p>
      </div>

      <Tabs defaultValue={activeView} onValueChange={setActiveView} className="space-y-6">
        <TabsList className="w-full justify-start bg-card border">
          <TabsTrigger value="courses" className="font-section data-[state=active]:bg-accent/20">
            <BarChart3Icon className="h-4 w-4 mr-2" />
            Courses
          </TabsTrigger>
          <TabsTrigger value="trainers" className="font-section data-[state=active]:bg-accent/20">
            <UsersIcon className="h-4 w-4 mr-2" />
            Trainers/Facilitators
          </TabsTrigger>
          <TabsTrigger value="demographics" className="font-section data-[state=active]:bg-accent/20">
            <BookOpenIcon className="h-4 w-4 mr-2" />
            Demographics
          </TabsTrigger>
          <TabsTrigger value="requirements" className="font-section data-[state=active]:bg-accent/20">
            <AwardIcon className="h-4 w-4 mr-2" />
            State Requirements
          </TabsTrigger>
        </TabsList>

        <TabsContent value="courses" className="m-0">
          <CourseFeedbackAnalytics />
        </TabsContent>
        
        <TabsContent value="trainers" className="m-0">
          <TrainerFeedbackAnalytics />
        </TabsContent>
        
        <TabsContent value="demographics" className="m-0">
          <DemographicFeedbackAnalytics />
        </TabsContent>
        
        <TabsContent value="requirements" className="m-0">
          <RequirementsFeedbackAnalytics />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default FeedbackAnalytics;
